import type React from 'react';

import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ChaptersIcon } from '../../icons/chapters';
import { Tooltip } from '../tooltip/tooltip';

import styles from './chapters-menu-button.module.css';

export const ChaptersMenuButtonName = 'chapters-menu-button';

type Props = {
  isActive?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export function ChaptersMenuButton({ isActive, className, onClick }: Props) {
  const { t } = useTranslation();

  const label = isActive ? t('ui.chapters.menu.button.label.active') : t('ui.chapters.menu.button.label.inactive');
  const button = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        data-testid={ChaptersMenuButtonName}
        type="button"
        name={ChaptersMenuButtonName}
        aria-expanded={isActive}
        aria-haspopup="true"
        className={classNames(styles.button, className)}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <ChaptersIcon />
      </button>
    ),
    [className, isActive, onClick]
  );
  return <Tooltip tooltip={label} trigger={button} />;
}
